import { useState } from 'react';

interface ProductImageGalleryProps {
  images: string[];
  productName: string;
  discount?: number;
  badge?: string;
}

export default function ProductImageGallery({ images, productName, discount, badge }: ProductImageGalleryProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="flex flex-col gap-4">
      <div className="relative aspect-square bg-ink-50 rounded-2xl overflow-hidden border border-ink-100">
        <img
          src={images[activeIndex]}
          alt={productName}
          className="w-full h-full object-contain p-6 transition duration-500"
        />
        {discount && (
          <span className="absolute top-4 left-4 h-7 px-3 rounded-full bg-cta-500 text-white text-xs font-bold flex items-center whitespace-nowrap">
            -{discount}%
          </span>
        )}
        {badge && (
          <span className="absolute top-4 right-4 h-7 px-3 rounded-full bg-white/90 backdrop-blur text-ink-800 text-xs font-bold flex items-center whitespace-nowrap">
            {badge}
          </span>
        )}
      </div>

      <div className="grid grid-cols-4 gap-3">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => setActiveIndex(i)}
            className={`relative aspect-square rounded-xl bg-ink-50 overflow-hidden border-2 transition ${
              i === activeIndex ? 'border-cta-500 shadow-soft' : 'border-transparent hover:border-ink-200'
            }`}
          >
            <img
              src={img}
              alt={`${productName} view ${i + 1}`}
              className="w-full h-full object-contain p-1.5"
            />
          </button>
        ))}
      </div>
    </div>
  );
}